import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { navbarTitleForPathname } from '../../utils/pageTitle';
import AppHamburgerMenu from './AppHamburgerMenu';
import NavbarCloseButton from '../shared/NavbarCloseButton';
import CubeSVG from '../cube-svgrepo-com.svg';
import './Navbar.css';

const ADMIN_HEADER_CLOSE_PATHS = [
    '/admin/bundle-thresholds',
    '/admin/bundle-scan-subset',
] as const;

function usesAdminHeaderClose(pathname: string): boolean {
    return ADMIN_HEADER_CLOSE_PATHS.some((path) => pathname === path);
}

interface NavbarProps {
    visible?: boolean;
    actionsSlotRef?: React.Ref<HTMLDivElement>;
    leftActionsSlotRef?: React.Ref<HTMLDivElement>;
}

const Navbar: React.FC<NavbarProps> = ({ visible = true, actionsSlotRef, leftActionsSlotRef }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = (): void => {
        void logout();
    };

    const isLandingPage = location.pathname === "/";
    const isBundleWorkList = location.pathname === '/bundle-work-orders';
    const showAdminClose = usesAdminHeaderClose(location.pathname);
    const pageTitle = navbarTitleForPathname(location.pathname);

    return (
        <nav className={`navbar ${visible ? '' : 'navbar-hidden'}`}>
            {isLandingPage ? (
                <div className="navbar-landing-container">
                    <div className="navbar-landing-left">
                        <img src={CubeSVG} alt="Red Cube" className="navbar-landing-cube" />
                        <span className="navbar-landing-title">KinkWare</span>
                    </div>
                    <button type="button" onClick={handleLogout} className="navbar-landing-logout">
                        Logout
                    </button>
                </div>
            ) : (
                <>
                    <div className="navbar-left-controls">
                        <div className="navbar-cube">
                            <Link to="/">
                                <img src={CubeSVG} alt="Red Cube" />
                            </Link>
                        </div>
                        <AppHamburgerMenu />
                    </div>
                    {pageTitle ? (
                        <h1 className="navbar-page-title">{pageTitle}</h1>
                    ) : (
                        <div className="navbar-page-title-spacer" />
                    )}
                    {isBundleWorkList ? <div className="navbar-title-balance" aria-hidden="true" /> : null}
                    {isBundleWorkList ? (
                        <div className="navbar-action-band">
                            <div className="navbar-left-page-actions" ref={leftActionsSlotRef} />
                            <div className="navbar-page-actions" ref={actionsSlotRef} />
                        </div>
                    ) : (
                        <div className="navbar-right-controls">
                            <div className="navbar-page-actions" ref={actionsSlotRef} />
                            {showAdminClose ? (
                                <NavbarCloseButton onClose={() => navigate('/admin')} />
                            ) : null}
                        </div>
                    )}
                </>
            )}
        </nav>
    );
};

export default Navbar;
